import React from 'react';
import { IconButton, Tooltip, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/pro-light-svg-icons';
import { ColorPalette } from '../../../../../components/config';

interface IAttendanceInternalNoteButtonProps {
  text?: string;
  isInternalNoteShown: boolean;
  onToggleInternalNote: () => void;
}

export function AttendanceInternalNoteButton({ text, isInternalNoteShown, onToggleInternalNote }: IAttendanceInternalNoteButtonProps) {
  function handleClick(event: React.MouseEvent<HTMLElement>) {
    event.stopPropagation();
    onToggleInternalNote();
  }

  const tooltip = (
    <Typography fontSize="0.75rem" whiteSpace="pre-wrap">
      {text}
    </Typography>
  );

  return (
    <Tooltip title={tooltip} placement="top-start">
      <IconButton aria-label="Intern note" aria-expanded={isInternalNoteShown} size="small" sx={{ fontSize: 'inherit', padding: 0.5 }} onClick={handleClick}>
        <FontAwesomeIcon icon={isInternalNoteShown ? faEye : faEyeSlash} color={ColorPalette.PrimaryMain} />
      </IconButton>
    </Tooltip>
  );
}
